import config from '../config';

type WatchGateInput = {
  settings?: Record<string, unknown> | null;
  accountFeatures?: Record<string, unknown> | null;
  localOverride?: boolean;
};

/**
 * Watch companion is enabled only when ALL three conditions are met:
 *
 *  1. build-time flag:  EXPO_PUBLIC_WATCH_COMPANION_ENABLED=true
 *  2. global gate:      system_settings.watch_companion_enabled = true
 *                       (admin controls whether the feature exists in the app at all)
 *  3. account toggle:   account.features.watch_companion_enabled = true
 *                       (the user enables it for their own account from Settings)
 */
export function isWatchCompanionEnabled(input: WatchGateInput = {}): boolean {
  const globalEnabled = input.settings?.watch_companion_enabled === true;
  const accountEnabled = input.accountFeatures?.watch_companion_enabled === true;
  return config.watch.enabled && globalEnabled && accountEnabled && input.localOverride !== false;
}

export function getWatchGateStatus(input: WatchGateInput = {}): {
  enabled: boolean;
  reasons: string[];
} {
  const reasons: string[] = [];
  if (!config.watch.enabled) reasons.push('build_flag_disabled');
  if (input.settings?.watch_companion_enabled !== true) reasons.push('global_flag_disabled');
  if (input.accountFeatures?.watch_companion_enabled !== true) reasons.push('account_flag_disabled');
  if (input.localOverride === false) reasons.push('local_override_disabled');
  return {
    enabled: isWatchCompanionEnabled(input),
    reasons,
  };
}
